// extracted by mini-css-extract-plugin
module.exports = {"container":"DetailsOriginalMode_container__y7ee2","wrapper":"DetailsOriginalMode_wrapper__z3ihS","closeButton":"DetailsOriginalMode_closeButton__2Bb34"};